import { memo } from 'react'

// Tapered arc — conic gradient fading Sunrise into a copper leading edge,
// cut to a 0.25rem ring stroke via mask.
const ARC_BACKGROUND = 'conic-gradient(from 0deg, transparent 25%, var(--color-accent) 70%, var(--color-progress))'
const ARC_MASK = 'radial-gradient(farthest-side, transparent calc(100% - 0.25rem), #000 calc(100% - 0.25rem + 0.5px))'

export const PageLoader = memo(function PageLoader({ message }: { message?: string }) {
  return (
    <div className="absolute inset-0 z-50 flex h-full items-center justify-center bg-background/80 backdrop-blur-sm">
      <div className="flex flex-col items-center gap-5 duration-700 animate-in fade-in">
        <div className="relative flex size-24 items-center justify-center">
          <div
            className="absolute inset-0 animate-spin rounded-full [animation-duration:1.4s]"
            style={{ background: ARC_BACKGROUND, mask: ARC_MASK, WebkitMask: ARC_MASK }}
          />
          {/* Logomark is a wide 1.76:1 sunburst with no intrinsic padding — size by
              width so horizontal and vertical clearance inside the ring stay even. */}
          <img src="/daisy_logomark_sunrise.png" alt="Daisy" className="relative w-14" />
        </div>
        <p className="text-sm font-medium text-muted-foreground">{message ?? 'Loading...'}</p>
      </div>
    </div>
  )
})
